import { sessionKeys } from "@/config/constants";
import { ApiCore } from "@/services/api/utils/core.js";
import { apiProvider } from "@/services/api/utils/provider.js";
import { handleError, handleResponse } from "@/services/api/utils/response.js";
import { formatDate } from "@/utils/format-date";
import axios from "axios";

const url = "notification-groups";

const api = new ApiCore({
	url: url,
});

/**
 *
 * @returns {Promise<{count: number, pivotNotificationId: number}>}
 */
api.getUnseen = async () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/unseen`)
		.then(handleResponse)
		.then((data) => {
			sessionStorage.setItem(sessionKeys.unseenPivotNotificationId, data[1].pivotNotificationId || "");
			return data;
		})
		.catch(handleError);
};

/**
 *
 * @param {number} pivotNotificationId
 * @param {number} limit
 */
api.getAll = (pivotNotificationId, onlyUnRead = false, limit = 8) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`, {
			params: {
				pivotNotificationId,
				limit,
				...(onlyUnRead ? { onlyUnRead } : {}),
			},
		})
		.then(handleResponse)
		.then((data) => {
			const notifications = data[1] || [];
			for (let n of notifications) {
				if (n?.created) {
					n.date = formatDate(n.created);
				}
			}
			return data;
		})
		.catch(handleError);
};

/**
 *
 * @param {number} pivotNotificationId
 */
api.markSeen = (pivotNotificationId) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/mark/seen`, {
			pivotNotificationId,
		})
		.then(handleResponse)
		.catch(handleError);
};

/**
 *
 * @param {Array<string>} notificationIds
 */
api.markRead = (notificationIds) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/mark/read`, { notificationIds })
		.then(handleResponse)
		.catch(handleError);
};

/**
 *
 * @param {number} pivotNotificationId
 */
api.markReadAll = (pivotNotificationId) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/mark/read/all`, {
			pivotNotificationId,
		})
		.then(handleResponse)
		.catch(handleError);
};

export default api;
